import React from 'react';
import { useState } from 'react';
import { Button, Typography } from 'react-covideo-common';
import { NewModal } from 'lib/components';
import { Dropdown } from 'lib/components';
import { SuperAdminUser } from 'lib/context';
import { VerificationStatusOptions } from 'lib/const/VerificationsStatusOptions';
import { VerificationStatus } from 'lib/const/VerificationStatus';
import { useBulkUpdateUsersCustomerAndStatus } from 'lib/api/superadmin/useBulkUpdateUsersCustomerAndStatus';
import { Flex } from 'lib/components/styles/layout';

const filteredStatusOptions = VerificationStatusOptions.filter(
  option => option.value !== VerificationStatus.ALL
);

type Props = {
  handleModalClose: (shouldRefresh?: boolean | number) => void;
  selectedUsers: SuperAdminUser[];
};

type OptionType = {
  value: string;
  label: string;
};

export const ChangeUserStatusModal = ({
  handleModalClose,
  selectedUsers,
}: Props) => {
  const [selectedStatus, setSelectedStatus] = useState(2);

  const headerText = `Change Status for ${selectedUsers.length} user${
    selectedUsers.length > 1 ? 's' : ''
  }`;

  const closeModal = () => {
    handleModalClose(1);
  };

  const { mutateAsync: updateUserStatus, isLoading: isUpdatingUserStatus } =
    useBulkUpdateUsersCustomerAndStatus(closeModal);

  const handleUpdateStatus = async () => {
    const userIds = selectedUsers.map(user => user.id);
    await updateUserStatus({
      userIds,
      status: selectedStatus,
    });
  };

  return (
    <NewModal
      headerText={headerText}
      hideHeader={false}
      closeModalOnBackdropOrEscPress={true}
      closeModal={() => handleModalClose()}
      headerMargin='0 0 24px 0'
      style={{
        content: {
          padding: '24px 24px 16px 24px',
          paddingLeft: '32px',
        },
      }}
    >
      <Flex gap='16px' flexDirection='column'>
        <Typography variant='normal'>
          You are about to {headerText?.toLowerCase()}
        </Typography>

        <Dropdown
          menuPosition='fixed'
          options={filteredStatusOptions}
          value={filteredStatusOptions.find(option => {
            return option && option.value === selectedStatus;
          })}
          onChange={(option: OptionType) =>
            setSelectedStatus(parseInt(option.value, 10))
          }
          menuPlacement='bottom'
          menuPortalTarget={document.body}
          placeholder={'Select New Status'}
        />
        <Button
          text={'Change Status'}
          style={{ width: 'fit-content', alignSelf: 'flex-end' }}
          onClick={() => handleUpdateStatus()}
          disabled={
            !(
              selectedStatus === VerificationStatus.ACTIVE ||
              selectedStatus === VerificationStatus.INACTIVE
            ) || isUpdatingUserStatus
          }
        />
      </Flex>
    </NewModal>
  );
};
